import React from "react";
import ContentLoader from "react-content-loader";
interface Props { }

const ContactDetailLoaderProfileData = (props: Props) => {
  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", margin: "45px 0px 20px 0px" }}>
        <div>
          <ContentLoader viewBox="0 0 150 40" height={40} width={150} {...props}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
          </ContentLoader>
        </div>
        <div>
          <ContentLoader viewBox="0 0 70 30" height={30} width={70} {...props}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
          </ContentLoader>
        </div>
      </div>
      <div style={{ margin: "40px 0px 30px 0px" }}>
        <ContentLoader viewBox="0 0 125 50" height={50} width={125} {...props}>
          <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
        </ContentLoader>
      </div>
      <div style={{ margin: "80px 0px 16px 0px" }}>
        <ContentLoader viewBox="0 0 285 35" height={35} width={285} {...props}>
          <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
        </ContentLoader>
      </div>
    </>
  );
};

export default ContactDetailLoaderProfileData;
